import { type ErrorModel } from './ErrorModel';

export class CometChatCallsException {
  code?: ErrorModel['code'];
  name?: ErrorModel['name'];
  message?: ErrorModel['message'];
  details?: ErrorModel['details'];
  constructor(errorModel: ErrorModel) {
    if ('code' in errorModel) this.code = errorModel.code;
    if ('name' in errorModel) this.name = errorModel.name;
    if ('message' in errorModel) this.message = errorModel.message;
    if ('details' in errorModel) this.details = errorModel.details;
  }
}
